<template>
  <div :class="['audio-item_wrap',{active:isPlay}]">
    <el-tooltip
      effect="dark"
      content="点击播放"
      :open-delay="1000"
      :hide-after="3000"
      placement="left"
    >
      <img
        class="audio-icon audio-icon_pause"
        :src="isPlay?aplay:audioIcon"
        @mouseover="mouseover"
        @mouseout="mouseout"
        @click="play"
      />
    </el-tooltip>
    <div class="audio-label">{{createdAt}} 录制</div>
  </div>
</template>

<script>
import nplay from "@/assets/images/survey/stat/nplay.svg";
import aplay from "@/assets/images/survey/stat/aplay.svg";
import moment from "moment";
export default {
  props: {
    audio: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      value: -1
    },
    currentIndex: {
      type: Number,
      value: -2
    }
  },
  data() {
    return {
      aplay,
      audioIcon: nplay
    };
  },
  computed: {
    isPlay() {
      return this.currentIndex === this.index;
    },
    createdAt() {
      const url = new URL(this.audio); //将音频地址转为URL对象
      const path = url.pathname; //取出链接的pathname
      const dotIndex = path.lastIndexOf("."); //查找path最后一个.的位置
      const slashIndex = path.lastIndexOf("/"); //查找path最后一个/的位置
      const str = path.substring(slashIndex + 1, dotIndex);
      const timestamp = str.split("_")[2]; //[type,surveyPostId,timestamp,randomNum]
      //取出的时间戳单位为秒，×1000转换为毫秒
      return moment(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  methods: {
    mouseover() {
      this.audioIcon = aplay;
    },
    mouseout() {
      this.audioIcon = nplay;
    },
    play() {
      this.$emit("play", {
        src: this.audio,
        index: this.index
      });
    }
  }
};
</script>

<style lang="less" scoped>
.audio-item_wrap {
  font-size: 0;
  padding: 7px 0;
  // background-color: #f4f4f5;
  color: #909399;
  border-radius: 4px;
}
.audio-item_wrap.active {
  // background-color: #e8f3ff;
  color: #1d82fc;
}
.audio-item_wrap + .audio-item_wrap {
  margin-top: 10px;
}
.audio-icon {
  display: inline-block;
  vertical-align: middle;
  width: 21px;
  height: 16px;
}
.audio-icon_pause {
  cursor: pointer;
}
.audio-label {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  line-height: 16px;
  margin-left: 10px;
}
</style>